<template v-if="ntpInfo.data.length > 0">
  <v-list class="list" style="background: transparent;">
    <v-list-group class="list-group" color="text_secondary--text">
      <template #activator>
        <v-list-item-title class="text_secondary--text subtitle-1 font-weight-medium mx-n4" :id="`title-${ntpInfo.testId}`">
          {{ ntpInfo.title }}
        </v-list-item-title>
      </template>
      <!-- array content -->
      <p v-for="(ntpParsedItem, k) in ntpParsedArray" :key="k" @click="$emit('click')">
        <template v-if="Object.keys(ntpParsedItem.title).length > 1">
          <v-list dense class="list">
            <v-list-group class="list-group">
              <!-- array item title -->
              <template #activator>
                <v-list-item-title class="text_secondary--text subtitle-1 font-weight-medium mx-n4">
                  <v-row justify="space-between">
                    <template v-if="ntpParsedItem.title.tallyCode">
                      <v-col px-2>
                        <strong>
                          {{ ntpParsedItem.title.tallyCode }}
                        </strong>
                      </v-col>
                    </template>
                    <template v-if="ntpParsedItem.title.remote">
                      <v-col px-2>
                        <strong>
                          {{ ntpParsedItem.title.remote }}
                        </strong>
                      </v-col>
                    </template>
                    <template v-if="ntpParsedItem.title.refid">
                      <v-col px-2>
                        <strong>
                          {{ ntpParsedItem.title.refid }}
                        </strong>
                      </v-col>
                    </template>
                  </v-row>
                </v-list-item-title>
              </template>
              <!-- item content -->
              <template v-if="(ntpParsedItem.content !== null && typeof ntpParsedItem.content === 'object')">
                <p v-for="(val, keyC) in ntpParsedItem.content" :key="keyC" @click="$emit('click')" class="pt-4">
                  <span v-if="val !== null && val !== ''" :key="`obj-${keyC}`">
                    <v-row justify="start" class="pl-2">
                      <v-col cols="auto" class="py-0 my-0">
                        <strong class="grey--text text--darken-2">
                          {{ $tc(`${keyC}:`) }}
                        </strong>
                      </v-col>
                      <v-col cols="auto" class="py-0 mb-0">
                        <p :id="`val-${ntpInfo.testId}`" class="py-0 my-0">{{ val }}</p>
                      </v-col>
                    </v-row>
                  </span>
                </p>
                <!-- <v-divider /> -->
              </template>
            </v-list-group>
          </v-list>
        </template>
        <template v-else>
          <strong>
            {{ ntpParsedItem.title.remote }}
          </strong>
        </template>
      </p>
    </v-list-group>
  </v-list>
</template>

<script>
export default {
  props: {
    ntpInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    ntpParsedArray () {
      const ntpRawContent = this.ntpInfo.data
      const ntpArray = []
      for (const ntpItem of ntpRawContent) {
        const ntpParsedItem = { title: {}, content: {} }
        const pattern = /^(.)([0-9]+\.[0-9]+\.[0-9]+\.[0-9]+) +(\.[A-Z]+\.|[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+) +([0-9]+) (.) +(-|[0-9]+) +([0-9]+) +([0-9]+) +([0-9]+(\.[0-9]+)?) +(-?[0-9]+(\.[0-9]+)?) +([0-9]+(\.[0-9]+)?)$/
        const myMatches = pattern.exec(ntpItem.ntpq_info)
        const tallyCodeParser = function (code) {
          switch (code) {
            case '*': return 'current time source'
            case '#': return 'source selected'
            case 'o': return 'PPS peer'
            case '+': return 'candidate'
            case '-': return 'outlyer'
            case 'x': return 'falseticker'
            case ' ': return 'source discarded'
            default: return 'source discarded'
          }
        }
        const typeParser = function (type) {
          switch (type) {
            case 'l': return 'local'
            case 'u': return 'unicast'
            case 'm': return 'multicast'
            case 'b': return 'broadcast'
            case '-': return 'netaddr'
            default: return 'unicast'
          }
        }
        const decimalToBin = function (val) {
          let num = val
          let binString = ''
          while (num !== 0) {
            binString += num % 2 ? '1' : '0'
            num = Math.floor(num / 2)
          }
          return binString
        }
        const reachParser = function (reach) {
          let fullBinaryString = ''
          for (const character of reach) {
            const charBin = decimalToBin(character)
            fullBinaryString += charBin
          }
          return fullBinaryString.padStart(8, '0')
        }
        if (myMatches) {
          ntpParsedItem.title.tallyCode = tallyCodeParser(myMatches[1])
          ntpParsedItem.title.remote = myMatches[2]
          ntpParsedItem.title.refid = myMatches[3]
          ntpParsedItem.content.stratum = myMatches[4]
          ntpParsedItem.content.type = typeParser(myMatches[5])
          ntpParsedItem.content.when = `${myMatches[6]} s`
          ntpParsedItem.content.pool = `${myMatches[7]} s`
          ntpParsedItem.content.reach = reachParser(myMatches[8])
          ntpParsedItem.content.delay = `${myMatches[9]} ms`
          ntpParsedItem.content.offset = `${myMatches[11]} ms`
          ntpParsedItem.content.jitter = `${myMatches[13]} ms`
        } else {
          // case when its is disabled
          ntpParsedItem.title.remote = ntpItem.addr
        }
        ntpArray.push(ntpParsedItem)
      }
      return ntpArray
    }
  },
  methods: {
    getNtpPasedItemTitle (ntpParsedItem) {
      const titleArray = []

      for (const titleComponent in ntpParsedItem.title) {
        titleArray.push(ntpParsedItem.title[titleComponent])
      }
      return titleArray.join(' - ')
    }
  }

}
</script>

<style lang="scss" scoped>
.list {
  padding: 0;
}

.list-group {
  &::before,
  &::after {
    background: none !important;
  }
}

.table {
  border: solid 1px #cbcbcb;
  border-collapse: collapse;
  border-spacing: 0;
  font: normal 13px Arial, sans-serif;
}
.table tr {
  border: solid 1px #cbcbcb;
  color: #336b6b;
  padding: 10px;
  text-align: left;
  text-shadow: 1px 1px 1px #fff;
}
.table td {
  border: solid 1px #cbcbcb;
  color: #333;
  padding: 10px;
  text-shadow: 1px 1px 1px #fff;
}
</style>
